<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formated"
        :label="label"
        :outlined="outlined"
        :disabled="disabled"
        dense
        append-icon="mdi-calendar"
        readonly
        :solo="solo"
        flat
        :hide-details="hide"
        :rules="rulesList"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      @change="$emit('input', date)"
      v-model="date"
      :max="max"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment-timezone";
import { FIELD } from "../assets/js/rules";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    outlined: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    max: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => {
        return FIELD;
      }
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      date: "",
      menu: false
    };
  },
  watch: {
    value() {
      if (this.value) {
        this.date = this.value.split("T")[0];
      } else {
        this.date = "";
      }
    }
  },
  computed: {
    rulesList() {
      return this.required ? this.rules : [];
    },
    formated() {
      if (!this.date) return "";
      return moment(this.date).format("MM/DD/YYYY");
    }
  },
  beforeMount() {
    if (this.value) {
      this.date = this.value.split("T")[0];
    } else {
      this.date = "";
    }
  }
};
</script>

<style></style>
